import { Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { environment } from 'src/environments/environment.prod';
import { NgIf } from '@angular/common';
import { FlexModule } from '@angular/flex-layout/flex';

@Component({
    selector: 'app-support',
    templateUrl: './support.component.html',
    styleUrls: ['../footer.component.scss'],
    standalone: true,
    imports: [FlexModule, NgIf]
})
/** *Support Component */
export class SupportComponent implements OnInit {
	public currentLanguageCode: string = '';
	@Input() showSupportHeader: boolean = true;
	homeUrl = 'https:whydonate.com';
	about = $localize`:@@footer_fundraiser_features_about_qr_url:about-whydonate-foundation`;
	blog = $localize`:@@footer_fundraiser_features_blog_qr_url:blog`;
	contact = $localize`:@@footer_fundraiser_features_contact_qr_url:contact-us`;
	tips = $localize`:@@footer_fundraiser_features_tips_url:fundraising-tips-and-tricks`;
	fees = $localize`:@@footer_fundraiser_features_fees_qr_url:fees`;
	feesHref: any;
	aboutHref: any;
	blogHref: any;
	contactHref: any;
	tipsHref: any;
	temp = 'https://whydonate.com/en/blog';
	constructor(private _accountService: AccountService) {}

	ngOnInit(): void {
		this.currentLanguageCode = this._accountService.getLocaleId();
		// if (this.currentLanguageCode == 'nl') {
		// 	this.aboutHref = `${environment.homeUrl}/${this.about}/`;
		// 	this.blogHref = `${environment.homeUrl}/${this.blog}/`;
		// 	this.contactHref = `${environment.homeUrl}/${this.contact}/`;
		// 	this.tipsHref = `${environment.homeUrl}/${this.tips}/`;
		// 	this.feesHref = `${environment.homeUrl}/${this.fees}/`;
		// } else {
		// 	this.aboutHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.about}/`;
		// 	this.blogHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.blog}/`;
		// 	this.contactHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.contact}/`;
		// 	this.tipsHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.tips}/`;
		// 	this.feesHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.fees}/`;
		// }
		this.aboutHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.about}/`;
		this.blogHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.blog}/`;
		this.contactHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.contact}/`;
		this.tipsHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.tips}/`;
		this.feesHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.fees}/`;
	}

	/** *url redirect for help desk */
	languageDetectorForHelpDesk(url: any) {
		window.location.href =
			url + '.whydonate.com' + '/' + this.currentLanguageCode;
	}
}
